<template>
  <div class="mapouter">
    <div class="gmap_canvas h-100">
      <div class="gmap_error" v-if="mapError">
        {{ mapErrorMsg }}
      </div>
      <div :id="'gmap-' + id"></div>
    </div>
  </div>
</template>

<script>
import gmapInit from '@/utils/gmap'

export default {
  name: 'Gmap',
  props: {
    id: {
      type: String,
      required: true
    },
    lat: {
      type: Number,
      required: true
    },
    lng: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      mapError: false,
      mapErrorMsg: 'Google Maps API erreur'
    }
  },
  async mounted () {
    try {
      const google = await gmapInit()
      const map = new google.maps.Map(document.getElementById('gmap-' + this.id), {
        center: {
          lat: this.lat,
          lng: this.lng
        },
        zoom: 13,
        scrollwheel: false,
        streetViewControl: false,
        mapTypeControl: false
      })
      const position = new google.maps.LatLng(this.lat, this.lng)
      // eslint-disable-next-line
      const marker = new google.maps.Marker({
        position,
        map
      })
      this.mapError = false
    } catch (error) {
      console.error(error)
      this.mapError = true
    }
  }
}
</script>

<style>
div[id^=gmap-client] {
  width: 100%;
  height: 200px;
}
#gmap-contact {
  height: 240px;
}
#gmap-company {
  height: 100%;
}
.gmap_canvas {
  position: relative !important;
}
.gmap_error {
  color: #9A9A9A;
  padding-left: 10px;
  padding-top: 10px;
  position: absolute;
  z-index: 10;
}
</style>
